import { InfoCircleFilled } from "@ant-design/icons";
import { useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";

const InfoText = ({
  text = "",
  className,
  style = {},
  hideOnMobile = true,
}) => {
  const isMobileView = useMediaQuery({
    query: "(max-width: 450px)",
  });
  const { isDarkMode } = useSelector((state) => state.usersList);
  const defStyle = {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    maxWidth: "800px",
    ...style,
    ...(isDarkMode ? { color: "#f9f9f9" } : {}),
  };
  return isMobileView && hideOnMobile ? null : (
    <div style={defStyle} className={className}>
      <InfoCircleFilled style={{ color: "#1da193", fontSize: "20px" }} />
      <span>{text}</span>
    </div>
  );
};
export default InfoText;
